
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ProfileSuggestionsResource,
} from '../models';
import {
    ProfileSuggestionsResourceFromJSON,
    ProfileSuggestionsResourceToJSON,
} from '../models';

/**
 * 
 */
export class ProfileSuggestionsApi extends runtime.BaseAPI {

    /**
     * Returns the ordered list of suggestions for the \"Suggested for you\" section. Empty when the task list is not fully completed. 
          */
    async getProfileSuggestionsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProfileSuggestionsResource>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProfileSuggestionsResource>({
            path: `/profile/api/profile-suggestions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProfileSuggestionsResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Returns the ordered list of suggestions for the \"Suggested for you\" section. Empty when the task list is not fully completed. 
          */
    async getProfileSuggestions(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProfileSuggestionsResource> {
        const response = await this.getProfileSuggestionsRaw(initOverrides);
        return response._data;
    }

}
